import { Close, Person } from '@mui/icons-material';
import { Box, Button, Divider, IconButton, Modal, Typography, useTheme } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { ModalBox } from '@frontend/features/common/utils/modals';

interface Props {
  open: boolean;
  onClose: (confirm: boolean) => void;
}

export const ConfirmDisableAgencyFlightIntegrationModal = ({ open, onClose }: Props) => {
  const theme = useTheme();
  const { t } = useTranslation();

  return (
    <Modal
      open={open}
      onClose={onClose}
      aria-labelledby="disable-flight-integration-title"
      aria-describedby="disable-flight-integration-description"
    >
      <ModalBox display="flex" flexDirection="column" gap={2}>
        <Box display="flex" gap={2}>
          <Box flexGrow={1} display="flex" alignItems="center" gap={1}>
            <Person color="disabled" />
            <Typography id="disable-flight-integration-title" variant="h6">
              {t('agencyFlightIntegrations.confirmDisableModal.title')}
            </Typography>
          </Box>
          <IconButton onClick={() => onClose(false)}>
            <Close color="primary" />
          </IconButton>
        </Box>
        <Divider />

        <Box display="flex" alignItems="center" gap={3} mb={3}>
          <Typography
            id="disable-flight-integration-description"
            variant="subtitle1"
            align="left"
            color={theme.palette.text.primary}
            sx={{
              flexGrow: 1,
            }}
          >
            {' '}
            {t('agencyFlightIntegrations.confirmDisableModal.message')}
          </Typography>
        </Box>
        <Box display="flex" flexDirection="column" gap={3} paddingTop={3}>
          <Divider />
          <Box
            display="flex"
            justifyContent="space-evenly"
            width="100%"
            gap={1}
            sx={{
              '& > button': {
                width: 'calc(50% - 4px)',
              },
            }}
          >
            <Button variant="outlined" color="primary" size="medium" onClick={() => onClose(false)}>
              {t('agencyFlightIntegrations.confirmDisableModal.cancel')}
            </Button>
            <Button variant="contained" color="error" size="medium" onClick={() => onClose(true)}>
              {t('agencyFlightIntegrations.confirmDisableModal.accept')}
            </Button>
          </Box>
        </Box>
      </ModalBox>
    </Modal>
  );
};
